<p class="app-version-value">v{{ appVersion }}</p>
